// FinancesTableRow.jsx
import React, { useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '../../../common/Buttons/Button';
import ButtonIcon from '../../../common/ButtonIcon/ButtonIcon';
import VocabularyButton from '../../../common/VocabularyButton/VocabularyButton';
import CourseName from '../../CourseName/CourseName';
import { homeworkColors } from '../../schedule/constants';

import useCountdown from '../hooks/useCountdown';
import Popover from '../Popover/Popover';

import '../common-countdown.styles.scss';

const FinancesTableRow = ({ course, getAccounts, getDocuments, type }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const setHomeworkPage = () => {
    localStorage.setItem('event', JSON.stringify(course));
    localStorage.setItem('eventId', JSON.stringify(course.event_id));
    localStorage.setItem('realHomeworkId', JSON.stringify(course.homework_id));
    navigate('/homework', { state: { from: location.pathname } });
  };

  const shouldPulse = course.homework_icon_color != 4;
  const hex = homeworkColors[course.homework_icon_color];
  const pulseStyle = shouldPulse ? { '--pulse-color': hex } : {};

  const { compact, full } = useCountdown(course.cancellation_lesson_date);
  const showCountdown = Boolean(course.cancellation_lesson_date);

  const [openInfo, setOpenInfo] = useState(false);
  const infoAnchorRef = useRef(null);
  const infoText = `Заняття будуть анульовані згідно з Договором через ${full || compact}`;

  return (
    <tr className='table-body__row'>
      <td className='table-body__cell'>
        <CourseName img={course.image} name={course.name} label={course.type} />
      </td>

      {type !== 'trial_courses' && (
        <>
          <td className='table-body__cell table-body__cell--center'>
            <div className="fin-cell fin-cell--table">
              <div className="fin-qtywrap">
                <div className="fin-qty">{course.qty || ''}</div>

                {showCountdown && (
                  <div className="fin-countdown">
                    <span className="fin-countdown__time">{compact}</span>
                    <button
                      ref={infoAnchorRef}
                      type="button"
                      className="fin-info-btn"
                      onClick={() => setOpenInfo(v => !v)}
                      aria-label="Докладніше"
                      title="Докладніше"
                    >
                      i
                    </button>

                    {openInfo && (
                      <Popover anchorRef={infoAnchorRef} onClose={() => setOpenInfo(false)}>
                        {infoText}
                      </Popover>
                    )}
                  </div>
                )}
              </div>
            </div>
          </td>

          <td className='table-body__cell table-body__cell--center'>
            {course.total || '-'}
          </td>
        </>
      )}

      {type === 'trial_courses' && (
        <td className='table-body__cell table-body__cell--center'>
          <div className="program-item__btns">
            {course.presentation_link && (
              <ButtonIcon
                classes='program-item__btn'
                icon='monitor'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => window.open(course.presentation_link, '_blank')}
              />
            )}
            {course.google_pdf_url && (
              <ButtonIcon
                classes='program-item__btn'
                icon='pdf'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => window.open(course.google_pdf_url, '_blank')}
              />
            )}
            {course.youtube_link && (
              <ButtonIcon
                classes='program-item__btn'
                icon='youtube'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => window.open(course.youtube_link, '_blank')}
              />
            )}
            {course.vocabulary_link && (
              <ButtonIcon
                classes='program-item__btn'
                icon='list'
                btnBg='white'
                iconColor='green'
                btnSize='lg'
                iconSize='md'
                onClick={() => window.open(course.vocabulary_link, '_blank')}
              />
            )}

            <VocabularyButton classes='program-item__btn' token={course.vocabulary_token} />
            {course.is_show_homework && (
              <div className="homework-icon-wrapper">
                {course.is_show_icon_new && <div className="new-badge">new</div>}
                <ButtonIcon
                  classes={`program-item__btn ${shouldPulse ? 'pulsing-icon' : ''}`}
                  icon='book'
                  btnBg='white'
                  iconColor={homeworkColors[course.homework_icon_color]}
                  btnSize='lg'
                  iconSize='md'
                  onClick={() => setHomeworkPage(course)}
                  style={pulseStyle}
                />
              </div>
            )}
          </div>
        </td>
      )}

      <td className='table-body__cell table-body__cell--center'>
        {type === 'course'
          ? ((course.status != 3)
            ? <Button buttonBg='green' loading='' onClick={() => getAccounts(course.product_id, type)}>Оплатити</Button>
            : '-')
          : <Button buttonBg='green' loading='' onClick={() => getAccounts(course.product_id, type)}>Оплатити</Button>
        }
      </td>

      {type !== 'trial_courses' && (
        <td className='table-body__cell table-body__cell--center'>
          <Button
            buttonBg="transparent link"
            tableClass="table__link"
            loading=""
            onClick={() => getDocuments(course.product_id)}
          >
            Переглянути
          </Button>
        </td>
      )}
    </tr>
  );
};

FinancesTableRow.propTypes = {
  course: PropTypes.object.isRequired,
  getDocuments: PropTypes.func.isRequired,
  getAccounts: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default FinancesTableRow;